export default function createPurchaseButton(element: HTMLElement) {
	Promise.all([
		import('react'),
		import('react-dom'),
		import('./buy-plan'),
	]).then(([React, ReactDOM, { default: BuyPlan }]) => {
		const id = element.getAttribute('data-buy-plan');

		if (!id) return;

		const label = element.textContent || undefined;

		const root = document.createElement('div');
		element.parentNode?.replaceChild(root, element);

		ReactDOM.render(<BuyPlan planId={id} label={label} />, root);
	});
}
